// Translations. Both dictionaries ship with the app (zh-TW is 18 KB): everything the student needs is loaded with
// the first page, and a locale switch (from the profile or the settings) never waits for a download. English is
// the fallback for every key zh-TW lacks.
import { addMessages, getLocaleFromNavigator, init, waitLocale } from 'svelte-i18n';
import en from './en.json';
import zhTW from './zh-TW.json';

addMessages('en', en);
addMessages('zh-TW', zhTW);

/** Starts with the browser's language; resolves once it is ready. */
export function startI18n() {
  init({ fallbackLocale: 'en', initialLocale: getLocaleFromNavigator() });
  return waitLocale();
}
